import { render, staticRenderFns } from "./TableComponents.vue?vue&type=template&id=fbcd4a18"
import script from "./TableComponents.vue?vue&type=script&lang=js"
export * from "./TableComponents.vue?vue&type=script&lang=js"
import style0 from "./TableComponents.vue?vue&type=style&index=0&id=fbcd4a18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports